(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var T13 = {
        brakD: __pewniaki_inline_cfg[0],
        brakZ: __pewniaki_inline_cfg[1],
        sr:    __pewniaki_inline_cfg[2],
        srMod: __pewniaki_inline_cfg[3],
        naj:   __pewniaki_inline_cfg[4],
        najMod:__pewniaki_inline_cfg[5]
    };

window.PEWNIAKI_ANALIZA = (function () {
    var TYPUJE = __pewniaki_inline_cfg[6], PULA = __pewniaki_inline_cfg[7];
    var tys = function (v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); };
    var f1 = function (v) { return v == null ? '—' : (Math.round(v * 10) / 10).toFixed(1).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var f2 = function (v) { return v == null ? '—' : (Math.round(v * 100) / 100).toFixed(2).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); };
    var pct = function (v) { return v == null ? '—' : f1(v * 100) + '%'; };

    // Jedna funkcja liczaca dla SSR-zgodnych wnioskow i renderu — te same liczby w obu miejscach.
    function policz(okno, dane) {
        var hist = (okno && okno.powtorzenia) || {};
        var mp = (dane && dane.model && dane.model.powtorzenia) || {};
        var typuje = Number((dane && dane.typuje) || TYPUJE), pula = Number((dane && dane.pula) || PULA);
        var n = 0, sumaR = 0, naj = null;
        Object.keys(hist).forEach(function (r) {
            var ile = Number(hist[r]) || 0;
            n += ile; sumaR += Number(r) * ile;
            if (ile > 0 && (naj === null || ile > hist[naj] || (ile === hist[naj] && Number(r) < Number(naj)))) naj = r;
        });
        var wiersze = [], ogon = 0, brak = false;
        for (var r = typuje; r >= 0; r--) {
            var p = mp[String(r)] != null ? Number(mp[String(r)]) : null;
            if (p == null) brak = true; else ogon += p;
            wiersze.unshift({ r: r, obs: Number(hist[String(r)]) || 0, p: p, ogon: brak ? null : ogon });
        }
        return {
            N: (okno && okno.losowan) || 0, n: n, hist: hist, mp: mp,
            srednia: n ? sumaR / n : null, eModel: pula ? typuje * typuje / pula : null,
            naj: naj, najIle: naj !== null ? Number(hist[naj]) : null, wiersze: wiersze
        };
    }

    return {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[8] + '/analizy/struktura.json',
        wersja: __pewniaki_inline_cfg[9],
        lata:   '/assets/json/db/' + __pewniaki_inline_cfg[10] + '/lata/',
        pula:   PULA,
        typuje: TYPUJE,
        // Zakres lat: suma SUROWYCH licznikow z rocznikow, mianownik = suma wartosci mapy.
        sumujLata: function (roczniki) {
            var hist = {}, N = 0, n = 0;
            roczniki.forEach(function (rok) {
                N += rok.losowan || 0;
                Object.keys(rok.powtorzenia || {}).forEach(function (r) { hist[r] = (hist[r] || 0) + (Number(rok.powtorzenia[r]) || 0); });
            });
            Object.keys(hist).forEach(function (r) { n += hist[r]; });
            return { losowan: N, powtorzenia: hist, powtorzen_n: n };
        },
        wnioski: function (okno, klucz, dane) {
            if (!okno) return [T13.brakD];
            var s = policz(okno, dane), p = [];
            if (s.srednia != null) p.push(T13.sr.replace('%1', tys(s.N)).replace('%2', tys(s.n)).replace('%3', f2(s.srednia))
                .replace('%4', s.eModel != null ? T13.srMod.replace('%1', f2(s.eModel)) : ''));
            if (s.naj !== null) p.push(T13.naj.replace('%1', s.naj).replace('%2', tys(s.najIle)).replace('%3', tys(s.n)).replace('%4', f1(s.najIle * 100 / s.n))
                .replace('%5', s.mp[s.naj] != null ? T13.najMod.replace('%1', pct(Number(s.mp[s.naj]))) : ''));
            return p.length ? p : [T13.brakZ];
        },
        render: function (okno, klucz, dane) {
            var q = function (sel) { return document.querySelector(sel); };
            var sekcja = q('[data-powtorzenia]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var s = policz(okno, dane);
            q('[data-powtorzenia-n]').textContent = tys(s.N);
            q('[data-powtorzenia-npar]').textContent = tys(s.n);
            q('[data-powtorzenia-srednia]').textContent = f2(s.srednia);
            q('[data-powtorzenia-model-e]').textContent = f2(s.eModel);
            q('[data-powtorzenia-naj]').textContent = s.naj !== null ? s.naj : '—';
            q('[data-powtorzenia-naj-ile]').textContent = s.najIle != null ? tys(s.najIle) : '—';
            q('[data-powtorzenia-zero]').textContent = s.n ? f1((Number(s.hist['0']) || 0) * 100 / s.n) + '%' : '—';
            q('[data-powtorzenia-zero-model]').textContent = s.mp['0'] != null ? pct(Number(s.mp['0'])) : '—';
            q('[data-powtorzenia-tabela] tbody').innerHTML = s.wiersze.map(function (w) {
                return '<tr><td class="liczbowa">' + w.r + '</td><td class="liczbowa">' + tys(w.obs) + '</td><td class="liczbowa">'
                     + (s.n ? f1(w.obs * 100 / s.n) + '%' : '—') + '</td><td class="liczbowa">' + pct(w.p)
                     + '</td><td class="liczbowa">' + pct(w.ogon) + '</td></tr>';
            }).join('');
        }
    };
})();
})();
